<template>
  <div id="user">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('task.system')" >
                <el-select v-model="filterForm.systemType" :placeholder="$t('task.chooseSystem')" @change="resetFilters()" clearable>
                  <el-option
                    v-for="item in systemOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('user.name')" >
                <el-input v-model="filterForm.name" :placeholder="$t('user.chooseName')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('user.cellphone')" >
                <el-input v-model="filterForm.cellphone" :placeholder="$t('user.choosePhone')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('filters.region')" >
                <el-select v-model="filterForm.regionNo" :placeholder="$t('filters.chooseRegion')" multiple clearable>
                  <el-option
                    v-for="item in regionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.reseller')" >
                <el-select v-model="filterForm.resellerNo" :placeholder="$t('filters.chooseReseller')" multiple clearable>
                  <el-option
                    v-for="item in resellerOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('user.role')" >
                <el-select v-model="filterForm.roleCode" :placeholder="$t('user.chooseRole')" multiple clearable>
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="18">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
<!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="filterBtns">
                  <el-button type="primary" @click="onAdd">{{ $t('user.addSub') }}</el-button>
                  <el-button type="primary" @click="onExport">{{ $t('export') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="tableLoading"
            >
              <el-table-column
                fixed
                prop="name"
                :label="$t('user.name')"
              >
              </el-table-column>
              <el-table-column
                prop="cellphone"
                :label="$t('user.cellphone')">
              </el-table-column>
              <el-table-column
                prop="email"
                :label="$t('user.email')"
              >
              </el-table-column>
              <el-table-column
                prop="systemName"
                :label="$t('task.system')"
              >
              </el-table-column>
              <el-table-column
                prop="roleName"
                :label="$t('user.role')"
              >
              </el-table-column>
              <el-table-column
                prop="regionName"
                :label="$t('filters.region')"
              >
              </el-table-column>
              <el-table-column
                prop="resellerName"
                :label="$t('filters.reseller')"
              >
              </el-table-column>
              <el-table-column
                :label="$t('operation')"
                width="120">
                <template slot-scope="scope">
<!--                  <el-button v-if="scope.row.permission" @click="editUser(scope.row)" type="text" size="small">{{ $t('edit') }}</el-button>-->
                  <el-button v-if="scope.row.permission" @click="deleteUser(scope.row)" type="text" size="small">{{ $t('delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <el-dialog
      :title="$t('user.addSub')"
      :visible.sync="CreateDialogVisible"
      width="40%"
      center
    >
      <el-form
        :model="userForm"
        ref="userForm"
        label-width="100px"
        class=""
      >
        <el-form-item :label="$t('user.cellphone')" prop="cellphone">
          <el-input :placeholder="$t('user.choosePhone')" @input="queryPhone" v-model="userForm.cellphone">
            <template slot="append"><el-button slot="append" icon="el-icon-search" @click="queryPhone"></el-button></template>
          </el-input>
          <span style="color: red" v-if="wrongPhone">该手机号不可用</span>
          <!--          <el-select v-model="userForm.resellerNo" :placeholder="$t('filters.chooseReseller')" style="width: 100%">-->
          <!--            <el-option-->
          <!--              v-for="item in resellerOptions"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
        </el-form-item>

        <el-form-item :label="$t('task.system')" >
          <el-select v-model="userForm.systemType" :placeholder="$t('task.chooseSystem')" style="width: 100%" @visible-change="resetInnerFilters()" clearable>
            <el-option
              v-for="item in innerSystemOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 暂时不要
        <el-form-item :label="$t('user.role')" >
          <el-select v-model="userForm.roleCode" :placeholder="$t('user.chooseRole')" style="width: 100%" >
            <el-option
              v-for="item in innerRoleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.region')" prop="regionNo">
          <el-select v-model="userForm.regionNo" :placeholder="$t('filters.chooseRegion')" style="width: 100%" >
            <el-option
              v-for="item in innerRegionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.reseller')" prop="resellerNo">
          <el-select v-model="userForm.resellerNo" :placeholder="$t('filters.chooseReseller')" style="width: 100%" >
            <el-option
              v-for="item in innerResellerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('user.locate')" prop="locate" v-if="userForm.systemType === 2">
          <el-select v-model="userForm.locate" :placeholder="$t('user.chooseLocate')" style="width: 100%" >
            <el-option
              v-for="item in locateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>-->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUser">{{ $t('save') }}</el-button>
        <el-button type="primary" @click="CreateDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('user.edit')"
      :visible.sync="EditDialogVisible"
      width="40%"
      center
    >
      <el-form
        :model="userForm"
        ref="userForm"
        label-width="100px"
        class=""
      >
        <el-form-item :label="$t('user.cellphone')" prop="cellphone">
          <el-input
            v-model="userForm.cellphone"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('task.system')" >
          <el-select v-model="userForm.systemType" :placeholder="$t('task.chooseSystem')" style="width: 100%" @visible-change="resetInnerFilters()" clearable>
            <el-option
              v-for="item in innerSystemOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.region')" prop="regionNo">
          <el-select style="width: 100%" v-model="userForm.regionNo" :placeholder="$t('filters.chooseRegion')" clearable>
            <el-option
              v-for="item in regionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.reseller')" >
          <el-select v-model="userForm.resellerNo" :placeholder="$t('filters.chooseReseller')" style="width: 100%">
            <el-option
              v-for="item in innerResellerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('user.role')" >
          <el-select v-model="userForm.roleCode" :placeholder="$t('user.chooseRole')" style="width: 100%">
            <el-option
              v-for="item in innerRoleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUser">{{ $t('save') }}</el-button>
        <el-button type="primary" @click="EditDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import PickDoor from "../../components/pickDoor";
export default {
  name: 'User',
  components: {
  },
  data: function () {
    return {
      radio: '1',
      systemOptions: [
      ],
      innerSystemOptions: [],
      CreateDialogVisible: false, // 新增人员
      EditDialogVisible: false, // 编辑人员
      operation: '', // 新增或编辑
      filterForm: {
      },
      initFilterForm: {
        systemType: '', // 系统
        cellphone: '', // 手机号
        regionNo: '', // 区域
        name: '', // 姓名
        resellerNo: '', // 客户
        roleCode: '', // 角色
      },
      userForm: {
      },
      initUserForm: {
        cellphone: '', // 手机号
        regionNo: '', // 区域
        resellerNo: '', // 客户
        roleCode: '', // 角色code
        id: 0, // 用户id
      },
      locateOptions: [
        {
          label: '中国大陆',
          value: 1
        },
        {
          label: '中国香港',
          value: 2
        },
        {
          label: '中国台湾',
          value: 3
        }
      ],
      regionOptions: [],
      innerRegionOptions: [],
      resellerOptions: [],
      innerResellerOptions: [],
      subResellerOptions: [],
      roleOptions: [],
      innerRoleOptions: [],
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      showRegion: false,
      showReseller: false,
      showRole: false,
      disableRole: false, // 新增时是否禁用选择角色
      wrongPhone: false,
    }
  },
  mounted () {
    this.getSystemOptions()
    this.getRangeList(true)
    this.getInnerRangeList(true)
    this.onReset()
  },
  methods: {
    getSystemOptions: async function () {
      let res = await window.instance.post(window.retailinkUrl + '/mqApi/systemType', _.assign(this.filterForm, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        console.log('res', res)
        this.systemOptions = _.map(res.data, (system) => ({
          itemKey: system.code,
          itemValue: system.desc,
        }))
        const totalOptions = _.cloneDeep(this.systemOptions)
        this.innerSystemOptions = _.remove(totalOptions, function(option) {
          return option.itemKey !== 1;
        });
      }
    },
    onExport: async function () {
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: window.retailinkUrl + "/accounts/accountExport",
        data: this.filterForm
      });
    },
    resetFilters: function () {
      this.filterForm.regionNo = ''
      this.filterForm.resellerNo = ''
      this.filterForm.roleCode = ''
      this.getRangeList()
    },
    resetInnerFilters: function () {
      this.userForm.regionNo = ''
      this.userForm.resellerNo = ''
      this.userForm.roleCode = ''
      this.getInnerRangeList()
    },
    // 用于获取外层筛选条件里的选项
    getRangeList: async function () {
      let filterParams = {
        //'roleCode': this.filterForm.roleCode,
        //'resellerNo': this.filterForm.resellerNo,
        'systemType': this.filterForm.systemType,
        // 'regionNo': this.filterForm.regionNo,
      }
      let submitParams = _.cloneDeep(filterParams)
      if (!this.filterForm.systemType) {
        submitParams = {}
      }
      let res = await window.instance.post(window.retailinkUrl + '/accounts/queryConditions', submitParams)
      res = res.data.data
      this.regionOptions = _.map(res.regionList, (region) => ({value: region.itemKey, label: region.itemValue}))
      this.roleOptions = _.map(res.roleList, (role) => ({value: role.itemKey, label: role.itemValue}))
      this.resellerOptions = _.map(res.resellerList, (reseller) => ({value: reseller.itemKey, label: reseller.itemValue}))
    },

    // 用于获取新增/编辑时候的选项
    getInnerRangeList: async function () {
      let filterParams = {
        //'roleCode': this.filterForm.roleCode,
        //'resellerNo': this.filterForm.resellerNo,
        'systemType': this.userForm.systemType,
        // 'regionNo': this.filterForm.regionNo,
      }
      let submitParams = _.cloneDeep(filterParams)
      if (!this.userForm.systemType) {
        submitParams = {}
      }
      let res = await window.instance.post(window.retailinkUrl + '/accounts/queryConditions', submitParams)
      res = res.data.data
      this.innerRegionOptions = _.map(res.regionList, (region) => ({value: region.itemKey, label: region.itemValue}))
      this.innerRoleOptions = _.map(res.roleList, (role) => ({value: role.itemKey, label: role.itemValue}))
      this.innerResellerOptions = _.map(res.resellerList, (reseller) => ({value: reseller.itemKey, label: reseller.itemValue}))
    },

    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let submitParams = this.$tool.formatArrayToString(this.filterForm)
      let res = await window.instance.post(window.retailinkUrl + '/accounts/listAccount', _.assign(submitParams, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        console.log('res.data', res.data)
        const list = res.data.records
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
      this.getRangeList(true)
    },
    onAdd: function () {
      this.CreateDialogVisible = true
      this.operation = this.$t('user.add')
      this.userForm = _.cloneDeep(this.initUserForm)
      this.getInnerRangeList()
    },
    editUser: function (user) {
      this.EditDialogVisible = true
      this.operation = this.$t('user.edit')
      this.userForm = {
        id: user.id,
        cellphone: user.cellphone,
        roleCode: user.roleCode,
        resellerNo: user.resellerNo,
        regionNo: user.regionNo,
        systemType: user.systemType
      }
      this.getInnerRangeList()
    },
    deleteUser: function (user) {
      const tipContent = this.$t('user.deleteUser') + '?'
      const tip = this.$t('tip')
      this.$confirm(tipContent, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          let res = await window.instance.post(window.retailinkUrl + '/accounts/delAccount/' + user.id)
          res = res.data
          if (res.code === 200) {
            await this.onSearch(true)
            this.$message.success(res.message)
          } else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => {})
    },

    submitUser: async function () {
      if (this.wrongPhone) {
        this.$message.error('该手机号不存在')
        return false
      }
      // 新建/编辑用户保存
      let res = await window.instance.post(window.retailinkUrl + '/accounts/editAccount', this.userForm )
      res = res.data
      if (res.code === 200) {
        this.EditDialogVisible = false
        this.CreateDialogVisible = false
        await this.onSearch(true)
        this.$message.success(res.message)
      }
    },

    queryPhone: async function () {
      if (this.userForm.cellphone.length > 7) {
        let res = await window.instance.post(window.retailinkUrl + '/accounts/checkCellPhone/' + this.userForm.cellphone )
        res = res.data
        if (res.code === 200) {
          console.log('用户手机号查询', res.data)
          this.wrongPhone = !res.data
        }
      }
    },

    getSelectedName: function (no, list) {
      if (!no) {
        return null
      }
      const selectedReseller = _.find(list, function (data) { return data.value === no })
      if (selectedReseller) {
        return selectedReseller.label
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped lang="sass">
#user
  .roleName
    color: #ff6801
    margin-left: 32px
    margin-bottom: 20px
  .roleCode
    margin-left: 32px
    margin-bottom: 14px
    label
      padding: 5px 0
</style>



// WEBPACK FOOTER //
// src/pages/setting/userManage.vue